// ── PowerBIDashboardsPage ──
import { useState, useEffect } from "react";
import { localFilter } from "../../../shared/format";
import { Btn, Card, ErrorMsg, Icon, STh, SearchBar, SectionHeader, Spinner, Td, TdNum, Th } from "../../../shared/ui";
import { useSortable } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const PowerBIDashboardsPage = () => {
    const { api, role, view, setModal, setConfirm, delRec, loadBiDashboards } = useApp();
    const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [err,setErr]=useState(null); const [q,setQ]=useState("");
    const load=()=>{setLoading(true);api.get("getPowerBIDashboards?includeInactive=1").then(d=>{setRows(d);setLoading(false);}).catch(e=>{setErr(e.message);setLoading(false);});};
    useEffect(()=>{load();},[]);
    const refresh=()=>{ load(); loadBiDashboards(); };
    const { sorted, sortKey, sortDir, toggle } = useSortable(localFilter(rows,q,["name","category","description"]), 'category');
    if(loading) return <Spinner />; if(err) return <ErrorMsg msg={err} onRetry={load} />;
    return <>
      <SectionHeader actions={[
        <SearchBar key="s" value={q} onChange={setQ} placeholder="Search dashboards..." />,
        role.canManageUsers&&<Btn key="a" onClick={()=>setModal({type:"bidashboard-add",onDone:refresh})} variant="primary">+ Add Dashboard</Btn>
      ].filter(Boolean)} />
      <Card style={{ overflowX:"auto" }}>
        <table style={{ width:"100%", borderCollapse:"collapse", whiteSpace:"nowrap" }}>
          <thead><tr>
            <STh label="Category" sortKey="category" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Name" sortKey="name" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Cat Order" sortKey="categoryorder" currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
            <STh label="Order" sortKey="displayorder" currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
            <STh label="Active" sortKey="isactive" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <Th></Th>
          </tr></thead>
          <tbody>{sorted.map(d=>(
            <tr key={d.id} style={{ cursor:"pointer" }} onClick={()=>setModal({type:"bidashboard-view",rec:d})}
                onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
              <Td style={{ fontWeight:500 }}>{d.category||"—"}</Td>
              <Td>{d.name||"—"}</Td>
              <TdNum>{d.categoryorder??"—"}</TdNum>
              <TdNum>{d.displayorder??"—"}</TdNum>
              <Td>{d.isactive?"Active":"Inactive"}</Td>
              <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }} onClick={e=>e.stopPropagation()}>
                <Btn onClick={()=>setModal({type:"bidashboard-view",rec:d})}><Icon type="view" /></Btn>
                {role.canManageUsers&&<Btn onClick={()=>setModal({type:"bidashboard-edit",rec:d,onDone:refresh})}><Icon type="edit" /></Btn>}
                {role.canManageUsers&&<Btn variant="danger" onClick={()=>setConfirm({msg:'Delete "'+(d.name||"")+'"?',onConfirm:()=>delRec("PowerBIDashboards",d.id,"Deleted dashboard",refresh)})}><Icon type="delete" /></Btn>}
              </div></Td>
            </tr>
          ))}</tbody>
        </table>
      </Card>
    </>;
  };
